
const VaultFileCard = ({description, icon}:any) => (
    <div className="bg-[#fff] p-3 md:p-6  flex items-center rounded-xl md:h-32 h-fit min-w-28 " >
        <div className=" h-full">
            {
            <img className="md:h-14 md:w-14 lg:w-18 lg:h-18 xl:w-32 xl:h-20 w-32 h-10 bg"  src={icon} alt={"description"} /> }
              <h3 className="text-lg text-left text-black mb-2 mt-8 ml-2" >{description}</h3>
        </div>
        <div className="w-2/3 h-full pl-2">
          
        </div>
        
    </div>
)

export default VaultFileCard
